import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const ExportOptionsModal = ({ show, onClose, onConfirm, initialOptions }) => {
  const [template, setTemplate] = useState('summary');
  const [orientation, setOrientation] = useState('portrait');
  const [format, setFormat] = useState('A4');

  useEffect(() => {
    if (initialOptions) {
      setTemplate(initialOptions.template || 'summary');
      setOrientation(initialOptions.orientation || 'portrait');
      setFormat(initialOptions.format || 'A4');
    }
  }, [initialOptions, show]);

  const handleConfirm = () => {
    onConfirm({ template, orientation, format });
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Exporter en PDF</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="mb-3">
            <Col sm={12} md={6}>
              <Form.Label>Format</Form.Label>
              <Form.Select value={format} onChange={(e) => setFormat(e.target.value)}>
                <option value="A4">A4</option>
                <option value="Letter">Letter</option>
              </Form.Select>
            </Col>
            <Col sm={12} md={6}>
              <Form.Label>Orientation</Form.Label>
              <Form.Select value={orientation} onChange={(e) => setOrientation(e.target.value)}>
                <option value="portrait">Portrait</option>
                <option value="landscape">Paysage</option>
              </Form.Select>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Type de rapport</Form.Label>
            <Form.Select value={template} onChange={(e) => setTemplate(e.target.value)}>
              <option value="summary">Résumé 1 page</option>
              <option value="full">Rapport complet</option>
            </Form.Select>
          </Form.Group>

          {/* Comments are handled by template type: Summary (no comments) vs Full (includes comments). */}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Annuler</Button>
        <Button variant="primary" onClick={handleConfirm}>Exporter</Button>
      </Modal.Footer>
    </Modal>
  );
};

ExportOptionsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  initialOptions: PropTypes.object,
};

export default ExportOptionsModal;
